import { createStore } from 'vuex'
import menus from './modules/menus'
import popups from './modules/popups'
import options from './modules/options'
import masks from './modules/masks'
import auth from './modules/auth'
import workers from './modules/workers'
import log from './modules/log'
import createPersistedState from "vuex-persistedstate";
const dataState = createPersistedState({
  paths: ['auth.localStorage']
})
export default createStore({
  state: {
  },
  mutations: {
    setNotifyPageVersion(state, data){
      state.notifyPageVersion = data;
    },
  },
  actions: {
  },
  modules: {
    menus,
    popups,
    options,
    masks,
    auth,
    workers,
    log,
  },
  plugins: [dataState]
})
